import { render } from "./balance-transfer-calculator.vue?vue&type=template&id=fd48df2e"
import script from "./balance-transfer-calculator.vue?vue&type=script&lang=js"
export * from "./balance-transfer-calculator.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\MVC\\wwwroot\\Frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__